<template>
    <CCard accent-color="secondary" class="mt-1 mb-1" border-color="secondary">
        <CCardHeader>
            <span style=" font-size: 26px;">TOTAL PAGO: </span>
            <span style=" font-size: 26px;">{{ (venta.credito.calculado + venta.debito.calculado + venta.mach.calculado + venta.mercadoPago.calculado) | dosDecimales }}</span>
        </CCardHeader>
        <CCardBody style="background-color: #F5F5F5;">
            <CCard>
                <CCardHeader>
                    <div class="card-header-actions">
                        <CLink class="card-header-action btn-minimize" @click="respaldar"
                            v-tippy="{ 
                                placement: 'top',
                                arrow: true, 
                                arrowType: 'round', 
                                animation:'fade',
                                theme: 'google',
                                followCursor : true,
                                content: 'Modificar Comision'
                            }">
                            <CIcon v-show="mostrarMas" :content="$options.freeSet.cilChevronTop" />
                            <CIcon v-show="!mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                        </CLink>
                    </div>
                    <center>
                        <span style="font-size: 14px;">Credito: <span class="font-weight-bold">{{ venta.credito.porcentaje }}% </span></span>|
                        <span style="font-size: 14px;">Debito: <span class="font-weight-bold">{{ venta.debito.porcentaje }}%</span> </span>|
                        <span style="font-size: 14px;">Mach: <span class="font-weight-bold">{{ venta.mach.porcentaje }}%</span> </span>|
                        <span style="font-size: 14px;">MercadoPago: <span class="font-weight-bold">{{ venta.mercadoPago.porcentaje }}%</span> </span>

                    </center>
                </CCardHeader>
                <CCollapse :show="mostrarMas" :duration="400">
                    <CCardBody>
                        <span>
                            <CInput
                                v-model="venta.credito.porcentaje"
                                label="% Credito"
                                type="text"
                                horizontal
                                placeholder="% Crédito"
                                @keyup="validarPorcentaje(venta.credito)"
                            /> 

                        </span>
                        <span>
                            <CInput
                                v-model="venta.debito.porcentaje"
                                label="% Débito"
                                type="text"
                                horizontal
                                placeholder="% Débito"
                                @keyup="validarPorcentaje(venta.debito)"
                            /> 
                        </span>
                        <span>
                            <CInput
                                v-model="venta.mach.porcentaje"
                                label="% mach"
                                type="text"
                                horizontal
                                placeholder="% mach"
                                @keyup="validarPorcentaje(venta.mach)"
                            /> 
                        </span>
                        <span>
                            <CInput
                                v-model="venta.mercadoPago.porcentaje"
                                label="% mercadoPago"
                                type="text"
                                horizontal
                                placeholder="% mercadoPago"
                                @keyup="validarPorcentaje(venta.mercadoPago)"
                            /> 
                        </span>
                        <CRow>
                            <CCol>
                                <CButton
                                    size="sm"
                                    class="btn-class"
                                    @click="guardar"
                                >
                                    <CIcon name="cil-check-circle" /> Guardar %
                                </CButton>
                                
                                <CButton
                                    size="sm"
                                    class="btn-class ml-2"
                                    @click="cancelar"
                                >
                                    <CIcon name="cil-x-circle" /> Cancelar
                                </CButton>
                            </CCol>
                            <CCol>
                                <CButton
                                    size="sm"
                                    class="btn-class float-right"
                                    @click="restaurar"
                                >
                                    Restaurar %
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCollapse>
                
            </CCard>
            <CRow>
                <CCol>
                    <CInput style=" font-size: 18px;"
                        v-model="venta.credito.valor"
                        label="Venta Credito"
                        type="text"
                        horizontal
                        placeholder="Venta Crédito"
                        @keyup="validarNumeros(venta.credito)"
                    /> 
                </CCol>
                <CCol v-if="venta.credito.calculado>0">
                    <div>
                        <span class="font-weight-bold">Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.credito.comision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">IVA Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.credito.ivaComision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Descuento Comisión: </span>
                        <span style=" font-size: 18px;">{{ (venta.credito.comision + venta.credito.ivaComision) | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Total: </span>
                        <span style=" font-size: 18px;">{{ venta.credito.calculado | dosDecimales }}</span>
                    </div>
                </CCol>
            </CRow>

            <hr>
            <CRow>
                <CCol>
                    <CInput style=" font-size: 18px;"
                        v-model="venta.debito.valor"
                        label="Venta Débito"
                        type="text"
                        horizontal
                        placeholder="Venta Débito"
                        @keyup="validarNumeros(venta.debito)"
                    /> 
                </CCol>
                <CCol v-if="venta.debito.calculado>0">
                    <div>
                        <span class="font-weight-bold">Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.debito.comision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">IVA Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.debito.ivaComision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Descuento Comisión: </span>
                        <span style=" font-size: 18px;">{{ (venta.debito.comision + venta.debito.ivaComision) | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Total: </span>
                        <span style=" font-size: 18px;">{{ venta.debito.calculado | dosDecimales }}</span>
                    </div>
                </CCol>
            </CRow>
            
            <hr>
            <CRow>
                <CCol>
                    <CInput style=" font-size: 18px;"
                        v-model="venta.mach.valor"
                        label="Venta mach"
                        type="text"
                        horizontal
                        placeholder="Venta mach"
                        @keyup="validarNumeros(venta.mach)"
                    /> 
                </CCol>
                <CCol v-if="venta.mach.calculado>0">
                    <div>
                        <span class="font-weight-bold">Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.mach.comision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">IVA Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.mach.ivaComision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Descuento Comisión: </span>
                        <span style=" font-size: 18px;">{{ (venta.mach.comision + venta.mach.ivaComision) | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Total: </span>
                        <span style=" font-size: 18px;">{{ venta.mach.calculado | dosDecimales }}</span>
                    </div>
                </CCol>
            </CRow>
            
            <hr>
            <CRow>
                <CCol>
                    <CInput style=" font-size: 18px;"
                        v-model="venta.mercadoPago.valor"
                        label="Venta mercadoPago"
                        type="text"
                        horizontal
                        placeholder="Venta mercadoPago"
                        @keyup="validarNumeros(venta.mercadoPago)"
                    /> 
                </CCol>
                <CCol v-if="venta.mercadoPago.calculado>0">
                    <div>
                        <span class="font-weight-bold">Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.mercadoPago.comision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">IVA Comisión: </span>
                        <span style=" font-size: 18px;">{{ venta.mercadoPago.ivaComision | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Descuento Comisión: </span>
                        <span style=" font-size: 18px;">{{ (venta.mercadoPago.comision + venta.mercadoPago.ivaComision) | dosDecimales }}</span>
                    </div>
                    <div>
                        <span class="font-weight-bold">Total: </span>
                        <span style=" font-size: 18px;">{{ venta.mercadoPago.calculado | dosDecimales }}</span>
                    </div>
                </CCol>
            </CRow>

            <CButton
                size="sm"
                class="btn-class"
                @click="calcular"
            >
                <CIcon name="cil-check-circle" /> Calcular
            </CButton>
            <!--<CRow>
                <CCol>
                    <CInput
                        v-model="producto.codigo"
                        label="Codigo Producto"
                        type="text"
                        horizontal
                        placeholder="Codigo Producto"
                    />
                    <barcode v-bind:value="producto.codigo">
                        Show this if the rendering fails.
                    </barcode>
                    <CInput
                        v-model="producto.nombre"
                        label="Nombre Producto"
                        type="text"
                        horizontal
                        placeholder="Nombre Producto"
                    />
                    <CInput
                        v-model="producto.proveedor"
                        label="proveedor Producto"
                        type="text"
                        horizontal
                        placeholder="proveedor Producto"
                    />
                    <CInput
                        v-model="producto.costo"
                        label="Costo Producto"
                        type="text"
                        horizontal
                        placeholder="Costo Producto"
                    />
                    <CInput
                        v-model="producto.precio"
                        label="Precio Producto"
                        type="text"
                        horizontal
                        placeholder="Precio Producto"
                    />
                    <CButton
                        size="sm"
                        class="btn-class"
                        @click="agregarPrdt"
                    >
                        <CIcon name="cil-check-circle" /> Agregar
                    </CButton>
                </CCol>
            </CRow>
            <br/>
            <CRow>
                <CCol>
                    <CButton
                        size="sm"
                        class="btn-class"
                        @click="getProductos"
                    >
                        <CIcon name="cil-check-circle" /> Actualizar Lista
                    </CButton>
                </CCol>
            </CRow>
            <CRow v-if="isLoadingProductos">
                <CCol md="12">
                    <center>
                        <img src="/img/logo2.png" size="custom-size" :height="50" class="imgr mt-3 mb-3" /> Obteniendo Información...
                    </center>
                </CCol>
            </CRow>
            <CRow v-if="!isLoadingProductos">
                <CCol>
                    <vs-table striped>
                        <template #header>
                            <CInput
                                v-model="busquedaProductos"
                                type="text"
                                horizontal
                                placeholder="Buscar"
                            />
                            """<vs-input
                            v-model="busquedaProductos"
                            border
                            placeholder="Buscar"
                            />"""
                        </template>
                        <template #thead>
                            <vs-tr>
                                <vs-th
                                    v-for="col in columnasProductos"
                                    :style="{ width: col.width }"
                                    v-bind:key="col.key"
                                    sort
                                    @click="productos = $vs.sortData($event, productos, col.key)"
                                >
                                    {{ col.title }}
                                </vs-th>
                            </vs-tr>
                        </template>
                        <template #tbody>
                            <vs-tr :key="i" v-for="(producto, i) in $vs.getPage($vs.getSearch(productos, busquedaProductos), page, max)"
                                :data="productos"
                            >
                                <vs-td>
                                    {{ producto.codigoProducto }}
                                </vs-td>
                                <vs-td>
                                    {{ producto.nombreProducto }}
                                </vs-td>
                                <vs-td>
                                    {{ producto.proveedor }}
                                </vs-td>
                                <vs-td>
                                    {{ producto.precio }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    
                    
                </CCol>
            </CRow>-->
        </CCardBody>
    </CCard>
</template>
    
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    
    import cons from '@/const'
    import Multiselect from 'vue-multiselect'
    import axios from "axios"
    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    
    import { freeSet } from "@coreui/icons";


    

    
    export default {
        name: 'PruebaProductos',
        freeSet,
        props: {
        },
        components: {
            Multiselect,
        
        },
        data () {
            return {
                
                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,
                producto: {
                    "codigo": "",
                    "nombre": "",
                    "proveedor": "",
                    "costo": 0,
                    "precio": 0
                },
                venta: {
                    debito: {valor: 0, porcentaje: 2.19, comision: 0, ivaComision: 0, calculado: 0},
                    credito: {valor: 0, porcentaje: 2.69, comision: 0, ivaComision: 0, calculado: 0},
                    mach: {valor: 0, porcentaje: 2.60, comision: 0, ivaComision: 0, calculado: 0},
                    mercadoPago: {valor: 0, porcentaje: 2.0, comision: 0, ivaComision: 0, calculado: 0},
                },
                locale: {
                    emptyText: ' '
                },

                page: 1,
                max: 1000,
                busquedaProductos: '',
                isLoadingProductos: false,
                productos:[],
                columnasProductos: [
                    { title: 'Código', scopedSlots:{ customRender: 'codigo' }, key: 'codigoProducto', width: '25%', ellipsis: true},// width: '10%'
                    { title: 'Nombre', scopedSlots:{ customRender: 'nombre' }, key: 'nombreProducto',  width: '25%', ellipsis: true},// width: '20%'
                    { title: 'Proveedor', scopedSlots:{ customRender: 'proveedor' }, key: 'proveedor',  width: '25%', ellipsis: true},// width: '20%'
                    {title: "Precio", scopedSlots: { customRender: 'precio' }, key: 'precio', width: "25%", align: "center"}// width: '20%'
                ],

                mostrarMas: false,
                respaldo: null,
            

            }
        },
        created: function(){},
        beforeMount() {
            //this.getProductos()
            this.venta.debito.porcentaje = localStorage.getItem('prcjDebito') || 2.19;
            this.venta.credito.porcentaje = localStorage.getItem('prcjCredito') || 2.69;
            this.venta.mach.porcentaje = localStorage.getItem('prcjMach') || 2.60;
            this.venta.mercadoPago.porcentaje = localStorage.getItem('prcjMP') || 2.0;

            /*
            localStorage.setItem('prcjDebito', this.venta.debito.porcentaje);
                localStorage.setItem('prcjCredito', this.venta.credito.porcentaje);
                localStorage.setItem('prcjMach', this.venta.mach.porcentaje); 
                localStorage.setItem('prcjMP', this.venta.mercadoPago.porcentaje);
                */
            
            

        },
        methods: {
            getProductos: function(){
                this.isLoadingProductos = true
                var url = this.baseUrl + "/get_prdt/"
                axios({
                    method: "GET", 
                    "url": url,
                }).then(result => {
                    this.productos = result.data.productos

                    this.isLoadingProductos = false
                    
                }, error => {
                    
                this.isLoadingProductos = false
                })
                .finally(() => {
                });
            },

            agregarPrdt: function(){
                var url = this.baseUrl + "/agregar_prdt/"
                axios({
                    method: "POST", 
                    "url": url,
                    data: {
                        "producto": this.producto
                    }
                }).then(result => {
                    console.log(result)
                    this.$notification.success(result.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                    this.getProductos()

                    
                }, error => {
                })
                .finally(() => {
                });
            },
            calcular: function(){
                this.calcularVenta(this.venta.credito)
                this.calcularVenta(this.venta.debito)
                this.calcularVenta(this.venta.mach)
                this.calcularVenta(this.venta.mercadoPago)
            },
            guardar: function(){
                this.mostrarMas = false

                localStorage.setItem('prcjDebito', this.venta.debito.porcentaje);
                localStorage.setItem('prcjCredito', this.venta.credito.porcentaje);
                localStorage.setItem('prcjMach', this.venta.mach.porcentaje); 
                localStorage.setItem('prcjMP', this.venta.mercadoPago.porcentaje);

            },
            restaurar: function(){
                this.venta.debito.porcentaje = 2.19
                this.venta.credito.porcentaje = 2.69
                this.venta.mach.porcentaje = 2.60
                this.venta.mercadoPago.porcentaje = 2.0 

            },
            cancelar: function(){
                this.mostrarMas = false
                this.venta.debito.porcentaje = this.respaldo.debito.porcentaje
                this.venta.credito.porcentaje = this.respaldo.credito.porcentaje
                this.venta.mach.porcentaje = this.respaldo.mach.porcentaje
                this.venta.mercadoPago.porcentaje = this.respaldo.mercadoPago.porcentaje

            },
            respaldar: function(){
                this.mostrarMas = !this.mostrarMas
                this.respaldo = JSON.parse(JSON.stringify(this.venta));
            },

            calcularVenta: function(tipoVenta){

                let cantidadARestar = tipoVenta.valor * (tipoVenta.porcentaje / 100);
                let iva = cantidadARestar * (19 / 100)
                tipoVenta.ivaComision = iva
                tipoVenta.comision = cantidadARestar
                let resultado = tipoVenta.valor - (cantidadARestar+iva);
                tipoVenta.calculado = resultado
            },

            validarNumeros: function(tipoVenta){
                let numAFormatear = tipoVenta.valor.toString().replace(/[^0-9]/g, "");
                tipoVenta.valor = numAFormatear
            },
            validarPorcentaje: function(tipoVenta) {
                let numAFormatear = tipoVenta.porcentaje.toString().replace(",", ".");

                // Permite solo dígitos y un único punto decimal
                numAFormatear = numAFormatear.replace(/[^0-9.]/g, ""); // Solo números y punto
                numAFormatear = numAFormatear.replace(/(\..*)\./g, "$1"); // Elimina puntos adicionales
                
                // Convierte a número flotante para validar
                let porcentaje = parseFloat(numAFormatear);
                
                // Validación de rango entre 0 y 100 o vacío
                if (!isNaN(porcentaje) && porcentaje >= 0 && porcentaje <= 100) {
                    tipoVenta.porcentaje = numAFormatear; // Mantiene el valor con el punto decimal
                } else {
                    tipoVenta.porcentaje = ""; // Si no es válido, se vacía el valor
                }
            }
            
            


        }
        
    }
</script>